export default "__VITE_ASSET__QqlX2CHt__"